import { render, staticRenderFns } from "./QuickMessagePicker.vue?vue&type=template&id=4c0cea5c&scoped=true"
import script from "./QuickMessagePicker.vue?vue&type=script&lang=js"
export * from "./QuickMessagePicker.vue?vue&type=script&lang=js"
import style0 from "./QuickMessagePicker.vue?vue&type=style&index=0&id=4c0cea5c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c0cea5c",
  null
  
)

export default component.exports